import { SupplierSubscriptionPlan } from '../../types/SupplierGroupSubscriptionMessage';
import { translate } from '../common/helpers/translate.helper';

export const getSupplierSubscriptionPlanActionLabel = (
    plan: SupplierSubscriptionPlan,
    currentPlan: SupplierSubscriptionPlan,
    planLabel: string | null
): string | null => {
    if (plan === currentPlan) {
        return translate('supplierSubscriptionPlans.currentPlan');
    }
    switch (plan) {
        case SupplierSubscriptionPlan.PROFESSIONAL:
            return translate('supplierSubscriptionPlans.upgrade');
        case SupplierSubscriptionPlan.ENTERPRISE:
            return translate('supplierSubscriptionPlans.contactSales');
        default:
            return planLabel;
    }
};
